export default class Modal {
  constructor(options) {
    this.opts = options;
    this.selector = '.' + this.opts.mainClass;
    this.render();
    this.modal = document.querySelector(this.opts.containerSelector + ' ' + this.selector);
    this.initialize();
    this.addCloseEvent();
  }

  render() {
    let modalsContainer = document.querySelector(this.opts.containerSelector);
    if (!modalsContainer) {
      return;
    }
    modalsContainer.classList.add(this.opts.containerClass);
    modalsContainer.appendChild(
      this.createEl(`
    <div class="modal ${this.opts.mainClass} my-center ${this.opts.additionalClasses}">
      <div class="modal-wrapper">
          <div class="modal-header d-flex">
            <div class="btn-back"></div>
            <div class="title title-sp text-center flex-grow-1"></div>
            <div class="btn-function btn-icon ${
              this.opts.clearButton ? 'icon-trash-alt-g clear-filters' : 'close-btn'
            }"></div>
          </div>
          <div class="modal-body d-flex flex-column">
            <div class="modal-body-header d-flex justify-content-between">
              <div class="modal-body-title"></div>
            </div>
            <div class="modal-body-content"></div>
          </div>
          <div class="modal-footer"></div>
      </div>
    </div>`)
    );
  }

  setVisible(visible) {
    this.modal.classList.toggle('active', visible);
  }
  addCloseEvent() {
    if (!this.opts.clearButton) {
      this.modal.querySelector('.close-btn').addEventListener('click', () => {
        this.setVisible(false);
      });
    }
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.setVisible(false);
      }
    });
  }
  initialize() {
    if (this.opts.title) {
      const element = this.modal.querySelector('.modal-header .title');
      if (element) {
        element.innerHTML = this.opts.title;
      }
    }
    if (this.opts.bodyTitle) {
      const element = this.modal.querySelector('.modal-body-title');
      if (element) {
        element.innerHTML = this.opts.bodyTitle;
      }
    }
    if (this.opts.body) {
      const element = this.modal.querySelector('.modal-body-content');
      if (element) {
        element.innerHTML = this.opts.body;
      }
    }
  }
  createEl(domstring) {
    const html = new DOMParser().parseFromString(domstring, 'text/html');
    return html.body.firstChild;
  }
}
